import { FleekError } from './FleekError';

type DomainHostnameInvalidErrorOptions = {
  hostname: string;
};

export class DomainHostnameInvalidError extends FleekError<DomainHostnameInvalidErrorOptions> {
  public name = 'DomainHostnameInvalidError';

  toString = () => {
    return `The domain ${this.data.hostname} is invalid`;
  };
}
